
export default {
    methods: {
        /**
         * 检查字符串是否为空（null/undefined/空字符串/纯空格）
         * @param {string} str - 待检查的字符串
         * @returns {boolean} 是否为空
         */
        isEmptyString(str) {
            return str === null ||
                str === undefined ||
                (typeof str === 'string' && str.trim() === '');
        },

        /**
        * 检查对象是否为空（null/undefined/无自身属性）
        * @param {Object} obj - 待检查的对象
        * @returns {boolean} 是否为空对象
        */
        isEmptyObject(obj) {
            // 处理 null/undefined
            if (obj == null) return true;

            // 处理非对象类型
            if (typeof obj !== 'object' || Array.isArray(obj)) return false;

            // 检查对象自身属性数量
            return Object.keys(obj).length === 0;
        }
    }
}